import { VODCSSModules } from 'shared/utils/wix-connect';

import VideoThumbnailOverlay from 'widget/views/desktop/compact/components/video-thumbnail-overlay/video-thumbnail-overlay';

import styles from './video-list-item.styl';


// Fix for css-modules:
// Need to be separated component with css-modules decorator instead of plain jsx to provide proper styles
@VODCSSModules(styles)
export default class VideoListItem extends React.Component {

  static propTypes = {
    OverlayActionsCallbacks: React.PropTypes.func,

    channelData: React.PropTypes.object,
    videoItem: React.PropTypes.object,
    currentSiteUser: React.PropTypes.object,

    width: React.PropTypes.number,
    height: React.PropTypes.number,
  };

  render() {
    const {
      channelData,
      videoItem,
      width,
      height,
      currentSiteUser,
      OverlayActionsCallbacks,
      } = this.props;

    return (
      <div styleName="container"
           style={{ height, width }}>
        <OverlayActionsCallbacks channelId={channelData.id}
                                 videoId={videoItem.id}>
          <VideoThumbnailOverlay width={width}
                                 height={height}
                                 currentSiteUser={currentSiteUser}
                                 channelData={channelData}
                                 videoItem={videoItem} />
        </OverlayActionsCallbacks>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/views/desktop/compact/components/videos/video-list-item/video-list-item.js